var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import EventEmitter from 'eventemitter3';
var SESSION_KEY = 'rmf_logged_in_user';
function makeToken(username) {
    // Create a fake JWT the backend StubAuthenticator can decode (no signature verification).
    // Backend reads: base64.b64decode(parts[1] + "==")["preferred_username"]
    var header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }));
    var payload = btoa(JSON.stringify({ preferred_username: username }));
    return "".concat(header, ".").concat(payload, ".stub");
}
var StubAuthenticator = /** @class */ (function (_super) {
    __extends(StubAuthenticator, _super);
    function StubAuthenticator() {
        var _this = _super.call(this) || this;
        var stored = sessionStorage.getItem(SESSION_KEY);
        _this._user = stored;
        _this._token = stored ? makeToken(stored) : undefined;
        return _this;
    }
    Object.defineProperty(StubAuthenticator.prototype, "user", {
        get: function () {
            var _a;
            return (_a = this._user) !== null && _a !== void 0 ? _a : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StubAuthenticator.prototype, "token", {
        get: function () {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    StubAuthenticator.prototype.setUser = function (username) {
        this._user = username;
        this._token = makeToken(username);
        sessionStorage.setItem(SESSION_KEY, username);
        this.emit('userChanged', username);
    };
    StubAuthenticator.prototype.init = function () {
        return Promise.resolve();
    };
    StubAuthenticator.prototype.login = function () {
        throw new Error('not supported');
    };
    StubAuthenticator.prototype.logout = function () {
        this._user = null;
        this._token = undefined;
        sessionStorage.removeItem(SESSION_KEY);
        this.emit('userChanged', null);
        window.location.href = '/login';
        return new Promise(function () { });
    };
    StubAuthenticator.prototype.refreshToken = function () {
        return Promise.resolve();
    };
    return StubAuthenticator;
}(EventEmitter));
export { StubAuthenticator };
export default StubAuthenticator;
